module.exports = __webpack_public_path__ + "img/evo-racing.e7da98ff.png";